import React from 'react';

function Footer() {

  return (
    <>
      <style dangerouslySetInnerHTML={{__html: `
        .tc-footer-style1 {
          background-color: #000;
          color: #fff;
          position: relative;
        }
        .tc-footer-style1 .top-content {
          padding: 80px 0 60px;
        }
        .tc-footer-style1 .logo-section {
          margin-bottom: 30px;
        }
        .tc-footer-style1 .logo-section .logo {
          max-height: 78px;
          margin-bottom: 20px;
        }
        .tc-footer-style1 .logo-section .company-name {
          font-size: 14px;
          color: #fff;
          line-height: 1.6;
          margin-bottom: 25px;
        }
        .tc-footer-style1 .service-desc {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
          margin-bottom: 30px;
        }
        .tc-footer-style1 .foot-social {
          display: flex;
          gap: 15px;
        }
        .tc-footer-style1 .foot-social a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        .tc-footer-style1 .foot-social a:hover {
          background: #73bf44;
          transform: translateY(-3px);
        }
        .tc-footer-style1 .foot-social a i {
          font-size: 16px;
        }
        .tc-footer-style1 .footer-brand {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 10px 0;
        }
        .tc-footer-style1 .footer-brand .logo {
          max-height: 320px;
          width: auto;
          object-fit: contain;
          margin-bottom: 24px;
          display: block;
        }
        .tc-footer-style1 .footer-brand .foot-social {
          margin-top: 0;
        }
        @media (max-width: 991px) {
          .tc-footer-style1 .footer-brand {
            align-items: center;
            text-align: center;
          }
          .tc-footer-style1 .footer-brand .logo {
            max-height: 260px;
          }
          .tc-footer-style1 .footer-brand .foot-social {
            justify-content: center;
          }
        }
        @media (max-width: 767px) {
          .tc-footer-style1 .footer-brand .logo {
            max-height: 200px;
          }
        }
        .tc-footer-style1 .contact-section {
          margin-bottom: 40px;
        }
        .tc-footer-style1 .contact-section h5 {
          font-size: 18px;
          font-weight: 600;
          color: #fff;
          margin-bottom: 20px;
        }
        .tc-footer-style1 .contact-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          line-height: 1.6;
        }
        .tc-footer-style1 .contact-item i {
          color: #73bf44;
          margin-right: 12px;
          margin-top: 4px;
          font-size: 16px;
          min-width: 20px;
        }
        .tc-footer-style1 .contact-item .contact-text {
          flex: 1;
        }
        .tc-footer-style1 .office-subtitle {
          display: block;
          color: #73bf44;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin: 8px 0 4px;
        }
        .tc-footer-style1 .sub-office-address {
          padding-left: 24px;
          margin-bottom: 8px;
        }
        .tc-footer-style1 .contact-item .contact-text a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          transition: color 0.3s ease;
        }
        .tc-footer-style1 .contact-item .contact-text a:hover {
          color: #73bf44;
        }
        .tc-footer-style1 .map-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .tc-footer-style1 .map-container .map-frame {
          height: 280px;
          border-radius: 8px;
          overflow: hidden;
        }
        .tc-footer-style1 .map-container iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }
        .tc-footer-style1 .foot {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding: 30px 0;
        }
        .tc-footer-style1 .foot p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 13px;
          margin: 0;
        }
        .tc-footer-style1 .foot-links {
          display: flex;
          gap: 20px;
          justify-content: flex-end;
          flex-wrap: wrap;
        }
        .tc-footer-style1 .foot-links a {
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          font-size: 13px;
          transition: color 0.3s ease;
          position: relative;
        }
        .tc-footer-style1 .foot-links a:not(:last-child)::after {
          content: '|';
          margin-left: 20px;
          color: rgba(255, 255, 255, 0.3);
        }
        .tc-footer-style1 .foot-links a:hover {
          color: #73bf44;
        }
        .whatsapp-float {
          position: fixed;
          bottom: 30px;
          right: 30px;
          z-index: 1000;
          width: 50px;
          height: 50px;
          border-radius: 8px;
          background: #73bf44;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-decoration: none;
          box-shadow: 0 4px 15px rgba(115, 191, 68, 0.4);
          transition: all 0.3s ease;
        }
        .whatsapp-float:hover {
          background: #8dd65a;
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(115, 191, 68, 0.6);
        }
        .whatsapp-float i {
          font-size: 24px;
        }
        @media (max-width: 991px) {
          .tc-footer-style1 .top-content {
            padding: 60px 0 40px;
          }
          .tc-footer-style1 .top-content .row {
            margin-left: -15px;
            margin-right: -15px;
          }
          .tc-footer-style1 .top-content .row > [class*="col-"] {
            padding-left: 15px;
            padding-right: 15px;
            margin-bottom: 40px;
          }
          .tc-footer-style1 .logo-section {
            margin-bottom: 0;
          }
          .tc-footer-style1 .logo-section .logo {
            max-height: 65px;
            margin-bottom: 15px;
          }
          .tc-footer-style1 .logo-section .company-name {
            font-size: 13px;
            margin-bottom: 20px;
          }
          .tc-footer-style1 .logo-section .service-desc {
            font-size: 13px;
            margin-bottom: 25px;
          }
          .tc-footer-style1 .contact-section {
            margin-bottom: 30px;
          }
          .tc-footer-style1 .contact-section h5 {
            font-size: 16px;
            margin-bottom: 15px;
          }
          .tc-footer-style1 .contact-item {
            font-size: 13px;
            margin-bottom: 12px;
          }
          .tc-footer-style1 .contact-item i {
            font-size: 14px;
            margin-right: 10px;
          }
          .tc-footer-style1 .map-container {
            grid-template-columns: 1fr;
            gap: 10px;
            margin-top: 0;
          }
          .tc-footer-style1 .map-container .map-frame {
            height: 220px;
          }
          .tc-footer-style1 .foot {
            padding: 25px 0;
          }
          .tc-footer-style1 .foot p {
            font-size: 12px;
            margin-bottom: 10px;
          }
          .tc-footer-style1 .foot-links {
            justify-content: flex-start;
            gap: 15px;
          }
          .tc-footer-style1 .foot-links a {
            font-size: 12px;
          }
          .whatsapp-float {
            bottom: 20px;
            right: 20px;
            width: 45px;
            height: 45px;
          }
        }
        @media (max-width: 767px) {
          .tc-footer-style1 .top-content {
            padding: 40px 0 30px;
          }
          .tc-footer-style1 .top-content .row {
            margin-left: -10px;
            margin-right: -10px;
          }
          .tc-footer-style1 .top-content .row > [class*="col-"] {
            padding-left: 10px;
            padding-right: 10px;
            margin-bottom: 35px;
          }
          .tc-footer-style1 .logo-section .logo {
            max-height: 58px;
            margin-bottom: 12px;
          }
          .tc-footer-style1 .logo-section .company-name {
            font-size: 12px;
            line-height: 1.5;
            margin-bottom: 15px;
          }
          .tc-footer-style1 .logo-section .service-desc {
            font-size: 12px;
            line-height: 1.5;
            margin-bottom: 20px;
          }
          .tc-footer-style1 .foot-social {
            gap: 12px;
          }
          .tc-footer-style1 .foot-social a {
            width: 36px;
            height: 36px;
          }
          .tc-footer-style1 .foot-social a i {
            font-size: 14px;
          }
          .tc-footer-style1 .contact-section {
            margin-bottom: 25px;
          }
          .tc-footer-style1 .contact-section h5 {
            font-size: 15px;
            margin-bottom: 12px;
          }
          .tc-footer-style1 .contact-item {
            font-size: 12px;
            line-height: 1.5;
            margin-bottom: 10px;
          }
          .tc-footer-style1 .contact-item i {
            font-size: 13px;
            margin-right: 8px;
            margin-top: 2px;
          }
          .tc-footer-style1 .contact-item .contact-text {
            word-break: break-word;
          }
          .tc-footer-style1 .map-container {
            grid-template-columns: 1fr;
            margin-top: 0;
          }
          .tc-footer-style1 .map-container .map-frame {
            height: 250px;
          }
          .tc-footer-style1 .foot {
            padding: 20px 0;
          }
          .tc-footer-style1 .foot .row {
            margin-left: -10px;
            margin-right: -10px;
          }
          .tc-footer-style1 .foot .row > [class*="col-"] {
            padding-left: 10px;
            padding-right: 10px;
          }
          .tc-footer-style1 .foot p {
            font-size: 11px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: center;
          }
          .tc-footer-style1 .foot-links {
            justify-content: center;
            margin-top: 0;
            gap: 10px;
            flex-wrap: wrap;
          }
          .tc-footer-style1 .foot-links a {
            font-size: 11px;
          }
          .tc-footer-style1 .foot-links a:not(:last-child)::after {
            margin-left: 10px;
          }
        }
        @media (max-width: 575px) {
          .tc-footer-style1 .top-content {
            padding: 30px 0 25px;
          }
          .tc-footer-style1 .top-content .row {
            margin-left: -8px;
            margin-right: -8px;
          }
          .tc-footer-style1 .top-content .row > [class*="col-"] {
            padding-left: 8px;
            padding-right: 8px;
            margin-bottom: 30px;
          }
          .tc-footer-style1 .logo-section .logo {
            max-height: 52px;
            margin-bottom: 10px;
          }
          .tc-footer-style1 .logo-section .company-name {
            font-size: 11px;
            margin-bottom: 12px;
          }
          .tc-footer-style1 .logo-section .service-desc {
            font-size: 11px;
            margin-bottom: 18px;
          }
          .tc-footer-style1 .foot-social {
            gap: 10px;
          }
          .tc-footer-style1 .foot-social a {
            width: 32px;
            height: 32px;
          }
          .tc-footer-style1 .foot-social a i {
            font-size: 12px;
          }
          .tc-footer-style1 .contact-section {
            margin-bottom: 20px;
          }
          .tc-footer-style1 .contact-section h5 {
            font-size: 14px;
            margin-bottom: 10px;
          }
          .tc-footer-style1 .contact-item {
            font-size: 11px;
            margin-bottom: 8px;
          }
          .tc-footer-style1 .contact-item i {
            font-size: 12px;
            margin-right: 6px;
          }
          .tc-footer-style1 .map-container {
            grid-template-columns: 1fr;
          }
          .tc-footer-style1 .map-container .map-frame {
            height: 180px;
          }
          .tc-footer-style1 .foot {
            padding: 18px 0;
          }
          .tc-footer-style1 .foot .row {
            margin-left: -8px;
            margin-right: -8px;
          }
          .tc-footer-style1 .foot .row > [class*="col-"] {
            padding-left: 8px;
            padding-right: 8px;
          }
          .tc-footer-style1 .foot p {
            font-size: 10px;
            margin-bottom: 12px;
          }
          .tc-footer-style1 .foot-links {
            gap: 8px;
          }
          .tc-footer-style1 .foot-links a {
            font-size: 10px;
          }
          .tc-footer-style1 .foot-links a:not(:last-child)::after {
            margin-left: 8px;
          }
          .whatsapp-float {
            bottom: 15px;
            right: 15px;
            width: 40px;
            height: 40px;
          }
          .whatsapp-float i {
            font-size: 20px;
          }
        }
      `}} />
      <footer className="tc-footer-style1">
        <div className="container">
          <div className="top-content section-padding">
            <div className="row gx-5">
              <div className="col-12 col-md-6 col-lg-4">
                <div className="footer-brand">
                  <img
                    src="/home_preview/assets/img/Logo-card-white.png"
                    alt="SEECA"
                    className="logo"
                  />
                  <div className="foot-social">
                    <a href="https://www.facebook.com/seecapl.pk/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://x.com/seeca_pk" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                      <i className="fab fa-x-twitter"></i>
                    </a>
                    <a href="https://www.instagram.com/seeca_pk/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://www.threads.net/@seeca_pk" target="_blank" rel="noopener noreferrer" aria-label="Threads">
                      <i className="fab fa-threads"></i>
                    </a>
                    <a href="https://www.pinterest.com/seeconsultantsarchitects/" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
                      <i className="fab fa-pinterest-p"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="contact-section">
                  <h5>Head Office</h5>
                  <div className="contact-item">
                    <i className="la la-map-marker"></i>
                    <div className="contact-text">
                      <span className="office-subtitle">Lahore Address</span>
                      <div className="sub-office-address">
                        903C, Maulana Shaukat Ali Road, Faisal Town, Lahore, Pakistan.
                      </div>
                      <span className="office-subtitle">Islamabad Office Address</span>
                      <div className="sub-office-address">
                        Plaza 138, First Floor, Wallayat Complex, Phase 7, Bahria Town, Islamabad.
                      </div>
                      <span className="office-subtitle">Jhelum Office Address</span>
                      <div className="sub-office-address">
                        C block, Bashir Tower, Citi housing, Jhelum, Pakistan.
                      </div>
                    </div>
                  </div>
                  <div className="contact-item">
                    <i className="la la-phone"></i>
                    <div className="contact-text">
                      <a href="tel:+923331498340">+92 333 1498340</a>
                      <br />
                      <a href="tel:+923247250008">+92 324 7250008</a>
                    </div>
                  </div>
                </div>
                <div className="contact-section">
                  <h5>Somalia Office</h5>
                  <div className="contact-item">
                    <i className="la la-map-marker"></i>
                    <div className="contact-text">
                      <span className="office-subtitle">Address</span>
                      <div className="sub-office-address">
                        Downtown Hargeisa, Road # 01, Office # 01 Hargeisa, Somaliland
                      </div>
                    </div>
                  </div>
                  <div className="contact-item">
                    <i className="la la-phone"></i>
                    <div className="contact-text">
                      <a href="tel:+252633810971">+252 633 8109 71</a>
                      <br />
                      <a href="tel:+252634633331">+252 634 6333 31</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-4">
                <div className="map-container">
                  <div className="map-frame">
                    <iframe
                      src="https://www.google.com/maps?q=903C,+Maulana+Shaukat+Ali+Road,+Faisal+Town,+Lahore,+Pakistan&output=embed"
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="SEECA Lahore Office Location"
                    ></iframe>
                  </div>
                  <div className="map-frame">
                    <iframe
                      src="https://www.google.com/maps?q=Plaza+138,+First+Floor,+Wallayat+Complex,+Phase+7,+Bahria+Town,+Rawalpindi,+Pakistan&output=embed"
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="SEECA Rawalpindi Office Location"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="foot">
            <div className="row">
              <div className="col-12 col-lg-6">
                <p>Copyright © 2025 SEECA by <span style={{ color: '#73bf44' }}> <a href="https://clapit.solutions" target="_blank" rel="noopener noreferrer"> CLAPIT.SOLUTIONS </a></span> All Rights Reserved.</p>
              </div>
              <div className="col-12 col-lg-6">
                <div className="foot-links">
                  <a href="#">Terms of use</a>
                  <a href="#">Privacy Environmental Policy</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

    </>
  );
}

export default Footer;
